import { getBioEntity } from './thunks/getBioEntity';
import { getMultiBioEntity } from './thunks/getMultiBioEntity';

export { getBioEntity, getMultiBioEntity };
